/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DownloadReportPricePdf$Params {
  reference: string;
}

export function downloadReportPricePdf(http: HttpClient, rootUrl: string, params: DownloadReportPricePdf$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, downloadReportPricePdf.PATH, 'get');
  if (params) {
    rb.path('reference', params.reference, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/pdf', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

downloadReportPricePdf.PATH = '/v1/api/admin-ui/company/pdf-price/{reference}';
